import clsx from 'clsx'
import { Navigate as navigate } from 'react-big-calendar'

/**
 * @typedef {Object} ViewNamesGroupProps
 * @property {string[]} views
 * @property {string} view
 * @property {Object<string, string>} messages
 * @property {function} onView
 */

/**
 * Compose a calendar view mode button.
 * @param {ViewNamesGroupProps} props
 * @return {JSX.Element}
 */
const ViewNamesGroup = ({ views, view, messages, onView }) => {
  const viewButtons = views.map((name) => (
    <button
      type="button"
      key={name}
      className={clsx({ 'rbc-active': view === name })}
      onClick={() => onView(name)}
    >
      {messages[name]}
    </button>
  ))

  return <>{viewButtons}</>
}

/**
 * @typedef {import('react-big-calendar').ToolbarProps} ToolbarProps
 */

/**
 * Custom toolbar composition.
 * @param {ToolbarProps} props
 * @return {JSX.Element}
 */
const CustomToolbar = ({
  // date, // available, but not used here
  label,
  localizer: { messages },
  onNavigate,
  onView,
  view,
  views,
}) => (
  <div className="rbc-toolbar">
    {/*
            <span className="rbc-btn-group">
              <ViewNamesGroup view={view} views={views} messages={messages} onView={onView} />
            </span>
      */}

    <span className={clsx('rbc-btn-group', 'examples--custom-toolbar')}>
      <button
        type="button"
        onClick={() => onNavigate(navigate.PREVIOUS)}
        aria-label={messages.previous}
      >
        &#60;
      </button>
      <span className="rbc-toolbar-label">{label}</span>
      <button type="button" onClick={() => onNavigate(navigate.NEXT)} aria-label={messages.next}>
        &#62;
      </button>
    </span>
  </div>
)

export default CustomToolbar
